export interface DiscoverieScopedQuery {
  baseQuery: string
  titleFilter?: string
  authorFilter?: string
}

export const parseDiscoverieScopedQuery = (
  query: string
): DiscoverieScopedQuery => {
  const titleOnlyMatch = query.match(/^@title:\s*(.+)$/i)

  if (titleOnlyMatch?.[1]?.trim()) {
    return {
      baseQuery: '',
      titleFilter: titleOnlyMatch[1].trim(),
    }
  }

  let remainingQuery = query
  const scopedFilters: DiscoverieScopedQuery = { baseQuery: '' }

  for (const field of ['title', 'author'] as const) {
    const scopeMatch = remainingQuery.match(
      new RegExp(`(?:^|\\s)@${field}:\\s*([^@]+)`, 'i')
    )

    if (scopeMatch?.[1]?.trim()) {
      scopedFilters[`${field}Filter`] = scopeMatch[1].trim()
      remainingQuery = `${remainingQuery.slice(
        0,
        scopeMatch.index
      )} ${remainingQuery.slice((scopeMatch.index ?? 0) + scopeMatch[0].length)}`
    }
  }

  return {
    ...scopedFilters,
    baseQuery: remainingQuery.replace(/\s+/g, ' ').trim(),
  }
}

export const buildDiscoverieScopedQuery = ({
  baseQuery,
  titleFilter,
  authorFilter,
}: DiscoverieScopedQuery) => {
  const parts = [baseQuery.trim()]

  if (titleFilter?.trim()) {
    parts.push(`@title: ${titleFilter.trim()}`)
  }

  if (authorFilter?.trim()) {
    parts.push(`@author: ${authorFilter.trim()}`)
  }

  return parts.filter(Boolean).join(' ').trim()
}
